import React from 'react';
import { CircularProgress } from '@mui/material';

const LoadingBadge = () => <CircularProgress size={10} color="secondary" />;

export default LoadingBadge;
